import { get } from "lodash";
import { NOTIFICATION_TYPES, SCREENS } from "utils/constants";

/**
 * Maps each notification type to an action handler or null.
 * actionHandler(notification, { navigate }) is called on "action" click (banner or list).
 * null = no action (no action button or click does nothing).
 */
export const NOTIFICATION_TYPE_ACTIONS = {
  [NOTIFICATION_TYPES.TASK_REMINDER]: (notification, { navigate }) => {
    const taskId = get(notification, "meta.taskId");
    if (taskId) {
      navigate(`${SCREENS.PRIVATE.BROKER.TASKS.LIST.path}?task=${taskId}`);
    }
  },
  [NOTIFICATION_TYPES.MISSED_CALL]: (notification, { navigate }) => {
    const contactId = get(notification, "meta.contactId");
    const projectId = get(notification, "meta.projectId");
    if (contactId) {
      const search = new URLSearchParams({ openContact: contactId });
      if (projectId) search.set("projectId", projectId);
      navigate(
        `${SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path}?${search.toString()}`,
      );
    }
  },
  [NOTIFICATION_TYPES.SYSTEM]: null,
};
